import * as Dialog from '@radix-ui/react-dialog';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { cn } from '~/lib/cn';

export const ModalDialogBody = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => {
  return (
    <Dialog.Description
      ref={ref}
      {...props}
      className={cn('overflow-y-auto px-xl pb-lg pt-sm', props.className)}
      asChild
    >
      <div>{children}</div>
    </Dialog.Description>
  );
});

ModalDialogBody.displayName = 'ModalDialog.Body';
